import React from 'react';

export const DeprecatedOfferPack: React.FC<{ onDismiss?: () => void }> = ({
  onDismiss,
}) => (
  <div className="tw-p-6 tw-text-center tw-text-sm tw-text-neutral-600">
    <p className="tw-font-semibold">Offer packs are deprecated</p>
    <p>This content is no longer available.</p>
    {onDismiss && (
      <button
        type="button"
        className="tw-mt-4 tw-underline"
        onClick={onDismiss}
      >
        Continue
      </button>
    )}
  </div>
);
